import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ViewChild, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProfileService } from '@shared/services';

export interface TableColumn {
    key: string;
    label: string;
    sortable?: boolean;
    sortActionDescription?: string;
}

export interface TableAction {
    icon: string;
    tooltip: string;
    action: string;
    materialSymbols?: boolean;
}

@Component({
    selector: 'overview-table',
    templateUrl: './overview-table.component.html',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatTableModule,
        MatSortModule,
        MatPaginatorModule,
        MatTooltipModule,
    ],
})
export class OverviewTableComponent implements OnInit, OnChanges {
    @Input() title = '';
    @Input() data: any[] = [];
    @Input() columns: TableColumn[] = [];
    @Input() actions: TableAction[] = [];
    @Input() isProcessing = false;
    @Input() addButtonText = 'Add table';
    @Input() addButtonIcon = 'create_new_fact_table';
    @Input() showRefreshButton = true;
    @Input() showAddButton = true;
    @Input() showFilterSection = false;
    @Input() filterFormGroup: any = null;

    @Output() addClicked = new EventEmitter<void>();
    @Output() refreshClicked = new EventEmitter<void>();
    @Output() actionClicked = new EventEmitter<{ action: string; element: any }>();

    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatPaginator) paginator!: MatPaginator;

    dataSource?: MatTableDataSource<any>;
    displayedColumns: string[] = [];

    constructor(public profileService: ProfileService) {}

    ngOnInit(): void {
        this.setupColumns();
        this.initDataSource();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data'] && this.data) {
            this.initDataSource();
        }
        if (changes['columns']) {
            this.setupColumns();
        }
    }

    private setupColumns(): void {
        this.displayedColumns = this.columns.map((col) => col.key);
        if (this.actions.length > 0) {
            this.displayedColumns.push('actions');
        }
    }

    private initDataSource(): void {
        this.dataSource = new MatTableDataSource(this.data);

        if (this.sort) {
            this.dataSource.sort = this.sort;
        }
        if (this.paginator) {
            this.dataSource.paginator = this.paginator;
        }
    }

    onAdd(): void {
        this.addClicked.emit();
    }

    onRefresh(): void {
        this.refreshClicked.emit();
    }

    onAction(action: string, element: any): void {
        this.actionClicked.emit({ action, element });
    }

    getColumnValue(element: any, columnKey: string): any {
        return element[columnKey];
    }
}
